import axiosInstance from "./axiosInstance";

export async function fetchTranscriptByRoomId(roomId, headers, version = "v1") {
  try {
    const res = await axiosInstance.django.get(
      `/voice/${version}/matching-logs/${roomId}/audio-files/call/transcripts/`,
      {
        headers: headers,
      }
    );
    if (res.status === 200) {
      return res.data.data;
    }
  } catch (error) {
    console.error(error);
    return [];
  }
}
